import React from 'react';
import classList from 'react-classlist-helper';
import { Parallax } from "react-parallax";
import SettingsContext from 'contexts/SettingsContext';

//Keyvis Video Logo
import keyvis_logo from 'assets/images/campaign/keyvis/keyvis_logo_mob.png';
import keyvis_logo_2x from 'assets/images/campaign/keyvis/keyvis_logo_mob@2x.png';

//Keyvis Video
import keyvis_video from 'assets/videos/gcw-hero-desk.mp4';
import keyvis_video_mob from 'assets/videos/gcw-hero-mob.mp4';


//player images
import keyvis_players_dt from 'assets/images/campaign/keyvis/keyvis_players_dt.png';
import keyvis_players_dt_2x from 'assets/images/campaign/keyvis/keyvis_players_dt@2x.png';
import keyvis_players_left_dt from 'assets/images/campaign/keyvis/keyvis_players_left_dt.png';
import keyvis_players_left_dt_2x from 'assets/images/campaign/keyvis/keyvis_players_left_dt@2x.png';
import keyvis_players_right_dt from 'assets/images/campaign/keyvis/keyvis_players_right_dt.png';
import keyvis_players_right_dt_2x from 'assets/images/campaign/keyvis/keyvis_players_right_dt@2x.png';
import keyvis_players_mob from 'assets/images/campaign/keyvis/keyvis_players_mob.png';
import keyvis_players_mob_2x from 'assets/images/campaign/keyvis/keyvis_players_mob@2x.png';

//Goldbar
import keyvis_gold_band from 'assets/images/campaign/keyvis/keyvis_gold_band.png'
import keyvis_gold_band_2x from 'assets/images/campaign/keyvis/keyvis_gold_band@2x.png'


//players names
import keyvis_players_dt_names from 'assets/images/campaign/keyvis/keyvis_players_dt_names.png';
import keyvis_players_dt_names_2x from 'assets/images/campaign/keyvis/keyvis_players_dt_names@2x.png';
import keyvis_players_mob_names from 'assets/images/campaign/keyvis/keyvis_players_mob_names.png';
import keyvis_players_mob_names_2x from 'assets/images/campaign/keyvis/keyvis_players_mob_names@2x.png';


//text images
import keyvis_text_dt from 'assets/images/campaign/keyvis/keyvis_text_dt.png';
import keyvis_text_dt_2x from 'assets/images/campaign/keyvis/keyvis_text_dt@2x.png';
import keyvis_text_tab from 'assets/images/campaign/keyvis/keyvis_text_tab.png';
import keyvis_text_tab_2x from 'assets/images/campaign/keyvis/keyvis_text_tab@2x.png';
import keyvis_text_mob from 'assets/images/campaign/keyvis/keyvis_text_mob.png';
import keyvis_text_mob_2x from 'assets/images/campaign/keyvis/keyvis_text_mob@2x.png';

import FadeIn from 'components/FadeIn/FadeIn';

import './HomeHero.scss';


export default (props) => {
  const [settings, setSettings] = React.useContext(SettingsContext);
  let compState = settings.competitionStatus.openState;
  let competitionIsNotStarted = compState === "NotStarted";

  const classes = {
    "home-hero": true,
    "home-hero--video": props.video
  }

  let parallaxMargin = 0;
  let parallaxPercentage = 80;
  let offsetParPercentage = 90;
  let strength = 100;
  var isDesk = window.matchMedia("only screen and (min-width: 640px)").matches;

  if (isDesk) {
    parallaxMargin = 0;
    strength = 100;
    parallaxPercentage = 0;
    offsetParPercentage = 140;
  }

  const offsetPercentage = (percentage) => {
    return percentage - offsetParPercentage;
  }

  return (
    <div className={classList(classes)}>
      <Parallax
        strength={strength}
        renderLayer={percentage => (
          <div className='home-hero-wrapper'>
            <div className="home-hero__bg"></div>
            
            {props.video ? (
              <>
              <FadeIn className='home-hero__logo'>
                <picture>
                  <img src={keyvis_logo} srcSet={keyvis_logo_2x + " 2x, " + keyvis_logo + " 1x"} alt="Game Changing Wins" />
                </picture>
              </FadeIn>
              <div className="home-hero__video">
                  <video autoPlay playsInline muted loop poster={props.poster}>
                  <source src={keyvis_video} type="video/mp4" media="(min-width:640px)" /> 
                  <source src={keyvis_video_mob} type="video/mp4" />
                   Your browser does not support the video tag.
                  </video>
              </div>
              
              </>
            ) : (

              <>
              <FadeIn className='home-hero__headline'>
                <picture>
                  <source type="image/png" srcSet={keyvis_text_dt_2x + " 2x, " + keyvis_text_dt + " 1x"} media="(min-width:640px)" />
                  <img src={keyvis_text_mob} srcSet={keyvis_text_mob_2x + " 2x, " + keyvis_text_mob + " 1x"} alt="Game Changing Wins" />
                </picture>
              </FadeIn>

              {props.names ? (
                  <picture>
                    <source type="image/png" srcSet={keyvis_players_dt_names_2x + " 2x, " + keyvis_players_dt_names + " 1x"} media="(min-width:640px)" />
  
                    <img src={keyvis_players_mob} srcSet={keyvis_players_mob_names_2x + " 2x, " + keyvis_players_mob_names + " 1x"} alt="Football players: Jill Scott, Lauren James, Katie McCabe and Leah Williamson."
                    className='home-hero__players' />
                  </picture>

              ) : (
                <>
 
                <picture>

                  <source type="image/png" srcSet={keyvis_players_left_dt_2x + " 2x, " + keyvis_players_left_dt + " 1x"} media="(min-width:640px)" />

                  <img src={keyvis_players_mob} srcSet={keyvis_players_mob_2x + " 2x, " + keyvis_players_mob + " 1x"} alt="Football players: Jill Scott, Lauren James, Katie McCabe and Leah Williamson."
                  className='home-hero__players'/>
                </picture>

                <picture>
                  <img src={keyvis_players_right_dt} srcSet={keyvis_players_right_dt_2x + " 2x, " + keyvis_players_right_dt + " 1x"} alt="Football players: Jill Scott, Lauren James, Katie McCabe and Leah Williamson."
                  className='home-hero__players home-hero__players--right'/>
                </picture>

                <picture>
                  <img src={keyvis_gold_band} srcSet={keyvis_gold_band_2x  + " 2x, " + keyvis_gold_band  + " 1x"} alt=""
                  className='home-hero__gold-band'/>
                </picture>

                </>

              )}


            </>
            )

            }


          </div>

        )}
      />

    </div>

  )
}